import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { getHTTPClient } from 'helpers'

class SideMenu extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            notifications: null,
            detailNotifications: false
        }
    }

    async componentDidMount() {
        this.setState({ notifications: await this.getNotifications() })
        if (this.state.notifications && this.state.notifications.notify.length){
            document.getElementById('notification-bell').classList.add('shake-horizontal')
            if (this.state.notifications.redFlag)
                document.getElementById('notification-bell').classList.add('red-bell')
        }
    }

    toggleActiveMenu(evt) {
        evt.currentTarget.classList.toggle('active')
        let children = evt.currentTarget.parentNode.children
        for (let i = 0; i < children.length; i++) {
            if (children[i] !== evt.currentTarget)
                children[i].classList.remove('active')
        }
    }

    toggleNotifications() {
        this.setState({ detailNotifications: !this.state.detailNotifications })
    }

    getNotifications() {
        const request = getHTTPClient()({
            method: 'GET',
            url: `/notifications`
        })

        return request.then(
            response => response.data.notifications,
            () => null
        )
    }

    render() {
        return (
            <div className="nav-wrapper">

                <nav id="navigation" className="navigator">
                    <ul className="nav">
                        <li onClick={event => this.toggleActiveMenu(event)} title="NOTIFICAÇÕES">
                            <span className="fa-stack">
                                <i className="fa fa-circle fa-stack-2x"></i>
                                <i id="notification-bell" className="fa fa-bell fa-stack-1x"></i>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">Notificações</li>
                                    {this.state.notifications && this.state.notifications.notify.length > 0 && this.state.notifications.notify.map((notification, idx) => {
                                        return (
                                            <li key={idx} className="submenu">
                                                {notification.text}
                                            </li>
                                        )
                                    })}
                                    {this.state.notifications && this.state.notifications.notify.length === 0 && <li className="submenu">Não há notificações.</li>}
                                </ul>
                            </div>
                        </li>
                        <li onClick={event => this.toggleActiveMenu(event)} title="CONFERÊNCIAS">
                            <span className="fa-stack">
                                <i className="fa fa-circle fa-stack-2x"></i>
                                <i className="fa fa-bullhorn fa-stack-1x"></i>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">S@T</li>
                                    <li className="submenu">
                                        <a target="_blank" rel="noopener noreferrer" href="https://satsp.fazenda.sp.gov.br/COMSAT/Account/LoginSSL.aspx?ReturnUrl=%2fCOMSAT">
                                            SGRSAT
                                        </a>
                                    </li>
                                    <li className="submenu">
                                        <a target="_blank" rel="noopener noreferrer" href="https://satsp.fazenda.sp.gov.br/COMSAT/Public/ConsultaPublica/ConsultaPublicaCfe.aspx">
                                            Consultar na Sefaz
                                        </a>
                                    </li>
                                    <li className="submenu">
                                        <Link to="/conferencia-sat">
                                            Conferência
                                        </Link>
                                    </li>
                                    <li className="submenu-title">NFC-e</li>
                                    <li className="submenu">
                                        <Link to="/conferencia-nfce">
                                            Conferência
                                        </Link>
                                    </li>
                                    <li className="submenu-title">Relatórios</li>
                                    <li className="submenu">
                                        <Link to="/movimentacao-todas-unidades">
                                            Movimento (Todas unidades)
                                        </Link>
                                    </li>
                                    <li className="submenu">
                                        <Link to="/receitas-financeiras">
                                            Receitas financeiras
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="" onClick={event => this.toggleActiveMenu(event)} title="EMPRESAS">
                            <span>
                                <span className="fa-stack">
                                    <i className="fa fa-circle fa-stack-2x"></i>
                                    <i className="fa fa-suitcase fa-stack-1x" style={{ color: '#003790'}}></i>
                                </span>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">Empresas</li>
                                    <li className="submenu">
                                        <a href='https://analisefiscal.rdpnet.com.br/1/fiscal-contabil/empresas' target='_blank' rel='noopener noreferrer'>
                                            Gerenciar
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="" onClick={event => this.toggleActiveMenu(event)} title="DOCSYSTEM">
                            <span>
                                <span className="fa-stack">
                                    <i className="fa fa-circle fa-stack-2x"></i>
                                    <i className="fa fa-file-alt fa-stack-1x" style={{ color: '#003790'}}></i>
                                </span>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">Docsystem</li>
                                    <li className="submenu">
                                        <Link to="/docsystem/pendencias">
                                            Consultar ID/Pendências
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="" onClick={event => this.toggleActiveMenu(event)} title="NOTAS FISCAIS">
                            <span>
                                <span className="fa-stack">
                                    <i className="fa fa-circle fa-stack-2x"></i>
                                    <i className="fa fa-stack-1x" style={{ color: '#003790'}}>NF</i>
                                </span>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">NF-E</li>
                                    <li className="submenu">
                                        <Link to="/nfes/consultar">
                                            Consultar
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="" onClick={event => this.toggleActiveMenu(event)} title="CT-e(s)">
                            <span>
                                <span className="fa-stack">
                                    <i className="fa fa-circle fa-stack-2x"></i>
                                    <i className="fa fa-stack-1x" style={{ color: '#003790', fontSize: '.9rem'}}>CTe</i>
                                </span>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">CT-e</li>
                                    <li className="submenu">
                                        <Link to="/ctes/consultar">
                                            Consultar
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="" onClick={event => this.toggleActiveMenu(event)} title="DRE">
                            <span>
                                <span className="fa-stack">
                                    <i className="fa fa-circle fa-stack-2x"></i>
                                    <i className="fa fa-stack-1x" style={{ color: '#003790', fontSize: '.85rem'}}>DRE</i>
                                </span>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">DRE</li>
                                    <li className="submenu">
                                        <a href='https://analisefiscal.rdpnet.com.br/1/fiscal-contabil/dre/perdas-devedores-duvidosos' target='_blank' rel='noopener noreferrer'>
                                            Perdas com Devedores Duvidosos
                                        </a>
                                    </li>
                                    <li className="submenu">
                                        <a href='https://analisefiscal.rdpnet.com.br/1/fiscal-contabil/dre/apuracao-icms' target='_blank' rel='noopener noreferrer'>
                                            Apuração ICMS
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="" onClick={event => this.toggleActiveMenu(event)} title="Icms">
                            <span>
                                <span className="fa-stack">
                                    <i className="fa fa-circle fa-stack-2x"></i>
                                    <i className="fa fa-stack-1x" style={{ color: '#003790', fontSize: '.85rem'}}>Icms</i>
                                </span>
                            </span>
                            <div>
                                <ul className="menu-container noselect">
                                    <li className="submenu-title">ICMS</li>
                                    <li className="submenu">
                                        <a href='https://analisefiscal.rdpnet.com.br/1/fiscal-contabil/regulamento-icms' target='_blank' rel='noopener noreferrer'>
                                            RICMS
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </nav>

            </div>
        )
    }

}

export default SideMenu